<div>
  <div class="error-400-title">
    <h1 style="display: inline">Error</h1>
    <h2 style="display: inline">4</h2>
    <h2 style="display: inline">0</h2>
    <h2 style="display: inline">0</h2>
  </div>
  <h1>Page Not Found</h1>
  <h2>The page you were navigating to currently does not exist</h2>
  <p-button variant="outlined" [routerLink]="['/dashboard']">Return to Dashboard</p-button>
</div>
